import styled from 'styled-components'

import { SettingsLanguagesList } from './settings-languages-list'

export const SettingsLanguages: React.FC = () => (
  <Root>
    <SettingsLanguagesList />
  </Root>
)

const Root = styled.div`
  display: grid;
  align-items: start;

  padding: 14px;
  gap: 14px;
`
